import {
    BrowserRouter,
    Navigate,
    Route,
    Routes
} from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Departments from "./pages/Departments";
import Profiles from "./pages/Profiles";
import AddProfile from "./pages/AddProfile";
import EditProfile from "./pages/EditProfile";
import AuditLogs from "./pages/AuditLogs";
import ProfilesReport from "./pages/ProfilesReport";
import Users from "./pages/Users";

// ======================================
// PROTECTED ROUTE COMPONENT
// ======================================
function ProtectedRoute({ children, allowRoles }) {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token) {
        // Redirect to login if not authenticated
        return <Navigate to="/login" replace />;
    }

    if (allowRoles && !allowRoles.includes(role)) {
        // Redirect to dashboard if authenticated but unauthorized
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/* PUBLIC ROUTES */}
                <Route
                    path="/"
                    element={<LandingPage />}
                />
                <Route
                    path="/login"
                    element={<Login />}
                />
                <Route
                    path="/register"
                    element={<Register />}
                />

                {/* PROTECTED ROUTES */}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/profiles"
                    element={
                        <ProtectedRoute>
                            <Profiles />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/departments"
                    element={
                        <ProtectedRoute allowRoles={["admin"]}>
                            <Departments />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/audit-logs"
                    element={
                        <ProtectedRoute allowRoles={["admin"]}>
                            <AuditLogs />
                        </ProtectedRoute>
                    }
                />

                {/* REPORTS */}
                <Route
                    path="/reports"
                    element={
                        <ProtectedRoute allowRoles={["admin"]}>
                            <ProfilesReport />
                        </ProtectedRoute>
                    }
                />

                {/* USER MANAGEMENT */}
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute allowRoles={["admin", "manager"]}>
                            <Users />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/add-profile"
                    element={
                        <ProtectedRoute allowRoles={["admin", "manager"]}>
                            <AddProfile />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/view-profile/:id"
                    element={
                        <ProtectedRoute>
                            <EditProfile viewOnly={true} />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/edit-profile/:id"
                    element={
                        <ProtectedRoute allowRoles={["admin", "manager"]}>
                            <EditProfile viewOnly={false} />
                        </ProtectedRoute>
                    }
                />

                {/* FALLBACK REDIRECT */}
                <Route
                    path="*"
                    element={<Navigate to="/" replace />}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;